'use client';

import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import {
  qr,
  Kr,
  $r,
  Ur,
  Wr,
  Xr,
  ti,
  ni,
  Jr,
  Yr,
  Zr,
  Qr,
  WorkbookWindow,
  WorkbookGrid,
  ei,
} from './workbook-grid';
import { Lr, Rr } from './apps-animation';
import { C } from './business-facts';
export const ri = [
  {
    head: !0,
    cells: [
      {
        v: 'Week of',
      },
      ...qr.map((e) => ({
        v: e,
      })),
    ],
  },
  {
    cells: [
      {
        v: 'Opening cash',
        at: 160,
      },
      ...Kr.slice(0, $r).map((e, t) => ({
        n: t === 0 ? Ur.openingCash / Wr : (Xr[t - 1] ?? 0),
        fmt: Lr,
        at: ti(t),
        f: t === 0 ? void 0 : `=${ni[t]}5`,
      })),
    ],
  },
  {
    cells: [
      {
        v: 'Receipts',
        at: 220,
      },
      ...Kr.slice(0, $r).map((e, t) => ({
        n: Jr(e),
        fmt: Lr,
        at: ti(t) + 40,
      })),
    ],
  },
  {
    cells: [
      {
        v: 'Payments',
        at: 280,
      },
      ...Kr.slice(0, $r).map((e, t) => ({
        n: -Yr(e),
        fmt: Lr,
        at: ti(t) + 80,
        tone: 'muted',
      })),
    ],
  },
  {
    total: !0,
    cells: [
      {
        v: 'Closing cash',
        at: 340,
      },
      ...Kr.slice(0, $r).map((e, t) => {
        let n = ni[t + 1] ?? 'B';
        return {
          n: Xr[t] ?? 0,
          fmt: Lr,
          at: ti(t) + 150,
          f: `=${n}2+${n}3+${n}4`,
        };
      }),
    ],
  },
];
export const ii = 2900;
export const ai = 70;
export const oi = 4060;
export const si = 4760;
export const ci = 5200;
export const ui = 520;
export const di = 136;
export const fi = 240;
export const pi = (e) => di - (e / fi) * di;
export function CashChart({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = ui / 13,
    n = e >= oi,
    r = (e) => e * t + t / 2,
    i = `M${r(0)},${pi(Xr[0] ?? 0)} ${Kr.map((e, t) => `L${r(t)},${pi(Xr[t] ?? 0)}`).join(' ')} ${[
      ...Kr,
    ]
      .reverse()
      .map((e, t) => {
        let n = Kr.length - 1 - t;
        return `L${r(n)},${pi(Zr[n] ?? 0)}`;
      })
      .join(' ')} Z`,
    a = `M${Kr.map((e, t) => `${r(t)},${pi(Zr[t] ?? 0)}`).join(' L')}`,
    o = r(Qr.week - 1);
  return (
    <figure
      className={
        'm-2 w-[calc(100%-16px)] rounded-md bg-[var(--background)] p-3 shadow-[inset_0_0_0_1px_var(--border),0_1px_2px_rgb(0_0_0/0.06)] lg:absolute lg:top-[204px] lg:left-[48px] lg:m-0 lg:w-[548px]'
      }
    >
      <figcaption
        className={
          'text-ink flex items-center justify-between gap-2 text-[12px] font-medium'
        }
      >
        {translateShowcaseNode(showcaseCopy, 'Closing cash by week')}
        <span className={'text-ink-4 num font-normal'}>
          {translateShowcaseNode(showcaseCopy, C.window)}
          {translateShowcaseNode(showcaseCopy, ' \xB7 illustrative')}
        </span>
      </figcaption>
      <svg
        viewBox={`0 -16 ${ui} 170`}
        className={'mt-2 block h-auto w-full overflow-visible'}
        role={'img'}
        aria-label={translateShowcaseNode(
          showcaseCopy,
          'Closing cash dips to $167,000 in week 9; the downside case reaches $111,200 that week.'
        )}
      >
        {translateShowcaseNode(
          showcaseCopy,
          [60, 120, 180, 240].map((e) => (
            <line
              key={e}
              x1={0}
              x2={ui}
              y1={pi(e)}
              y2={pi(e)}
              stroke={'var(--border)'}
              strokeDasharray={'2 3'}
              opacity={0.7}
            />
          ))
        )}
        <path
          d={i}
          fill={'var(--ref-violet)'}
          opacity={n ? 0.1 : 0}
          style={{
            transition: 'opacity 500ms var(--ease)',
          }}
        />
        {translateShowcaseNode(
          showcaseCopy,
          Xr.map((n, i) => {
            let a = e >= ii + i * ai,
              o = i === Qr.week - 1,
              s = i * t + t * 0.2,
              c = t * 0.6;
            return (
              <g key={i}>
                <rect
                  x={s}
                  y={pi(n)}
                  width={c}
                  height={di - pi(n)}
                  rx={2}
                  className={'bz-bar'}
                  fill={o && e >= si ? 'var(--ref-amber)' : 'var(--foreground)'}
                  opacity={o && e >= si ? 0.95 : 0.7}
                  style={{
                    transform: `scaleY(${+!!a})`,
                    transformOrigin: `${s + c / 2}px ${di}px`,
                  }}
                />
                <text
                  x={r(i)}
                  y={151}
                  textAnchor={'middle'}
                  className={'fill-[var(--muted-foreground)] text-[10px]'}
                >
                  {translateShowcaseNode(showcaseCopy, i + 1)}
                </text>
              </g>
            );
          })
        )}
        <path
          d={a}
          fill={'none'}
          stroke={'var(--ref-violet)'}
          strokeWidth={1.4}
          strokeDasharray={'4 3'}
          style={{
            clipPath: n
              ? 'inset(-8px -8px -8px -8px)'
              : 'inset(-8px 100% -8px -8px)',
            transition: 'clip-path 900ms var(--ease)',
          }}
        />
        <line x1={0} x2={ui} y1={di} y2={di} stroke={'var(--border)'} />
        <g
          style={{
            opacity: +(e >= si),
            transition: 'opacity 300ms var(--ease)',
          }}
        >
          <text
            x={o}
            y={pi(Xr[Qr.week - 1] ?? 0) - 6}
            textAnchor={'middle'}
            className={
              'num fill-[var(--foreground)] text-[10.5px] font-semibold'
            }
          >
            {translateShowcaseNode(showcaseCopy, '$167k')}
          </text>
          <circle
            cx={o}
            cy={pi(Qr.downside / Wr)}
            r={3}
            fill={'var(--background)'}
            stroke={'var(--ref-violet)'}
            strokeWidth={1.5}
          />
          <rect
            x={o - 46}
            y={pi(Qr.downside / Wr) + 8}
            width={92}
            height={18}
            rx={9}
            fill={'var(--background)'}
            stroke={'color-mix(in srgb, var(--ref-violet) 45%, transparent)'}
          />
          <text
            x={o}
            y={pi(Qr.downside / Wr) + 20.5}
            textAnchor={'middle'}
            className={'num fill-[var(--ref-violet)] text-[10.5px] font-medium'}
          >
            {translateShowcaseNode(showcaseCopy, 'Downside $111.2k')}
          </text>
        </g>
      </svg>
    </figure>
  );
}
export function CashDecision() {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div
      className={
        'enter pop rounded-2xl p-1.5 lg:absolute lg:top-3 lg:right-3 lg:w-[284px]'
      }
    >
      <div className={'rounded-[10px] p-3'}>
        <p className={'text-ink-3 flex items-center gap-2 text-[12px]'}>
          <ShowcaseIcon name={'doc'} className={'size-4'} />
          {translateShowcaseNode(showcaseCopy, 'Funding action brief')}
        </p>
        <p
          className={
            'num text-ink mt-2 text-[14px] leading-5 font-medium tracking-[-0.006em]'
          }
        >
          {translateShowcaseNode(
            showcaseCopy,
            'Lowest point: $167,000 in week '
          )}
          {translateShowcaseNode(showcaseCopy, Qr.week)}
        </p>
        <p className={'text-ink-3 mt-1 text-[12.5px] leading-[1.5]'}>
          {translateShowcaseNode(showcaseCopy, 'Week ending ')}
          {translateShowcaseNode(showcaseCopy, Qr.weekEnding)}
          {translateShowcaseNode(
            showcaseCopy,
            ', when the second production payment falls due.'
          )}
        </p>
        <div
          className={
            'mt-2.5 flex items-start gap-2 rounded-[10px] bg-[color-mix(in_srgb,var(--ref-violet)_9%,transparent)] p-2.5 text-[12.5px] leading-[1.45] shadow-[inset_0_0_0_1px_color-mix(in_srgb,var(--ref-violet)_28%,transparent)]'
          }
        >
          <ShowcaseIcon
            name={'zap'}
            className={'mt-px size-4 shrink-0 text-[var(--ref-violet)]'}
          />
          <span className={'num text-ink'}>
            {translateShowcaseNode(
              showcaseCopy,
              'Downside reaches $111,200 that week. '
            )}
            {translateShowcaseNode(showcaseCopy, C.downsideRule)}
          </span>
        </div>
      </div>
    </div>
  );
}
export function CashForecast({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = Rr(ri, e, 260);
  return (
    <WorkbookWindow
      title={translateShowcaseNode(
        showcaseCopy,
        'Mercer & Vale 13-week cash forecast'
      )}
      version={'v1'}
      file={'Cash-forecast.sheet'}
      tabs={['13-week forecast', 'Inputs', 'Downside', 'Funding brief']}
      activeTab={0}
      formula={t}
      approved={e >= 6800}
    >
      <WorkbookGrid
        label={'13-week cash forecast'}
        columns={ei}
        rows={ri}
        t={e}
        pick={t}
        extra={8}
        minRows={13}
      />
      <CashChart t={e} />
      <div className={'m-2 min-h-[188px] lg:contents'}>
        {translateShowcaseNode(showcaseCopy, e >= ci ? <CashDecision /> : null)}
      </div>
    </WorkbookWindow>
  );
}
export const gi = [610, 150, 228, 212, 262, 490];
export const _i = [120, 260, 220, 240, 200, 110];
export const vi = 5;
export const yi = 452;
export const bi = 63.5;
export const xi = 5200;
export const Si = 6400;
